export default __webpack_public_path__ + "static/media/avatar.058bb6f9.svg";